var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"content-height",attrs:{"nobody":""}},[_c('div',{class:_vm.name,attrs:{"job_id":_vm.args.job_id}},[_c('pre',[_c('code',{staticClass:"text-normalwrap"},[_vm._v(_vm._s(_vm.jobContent))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }